// @ts-nocheck
import setHeaderHeight from "@store/Framework/Store/Bunzl/Components/Header/Handlers/SetHeaderHeight";
import { HeaderHeightParameter } from "@store/Framework/Store/Bunzl/Components/Header/HeaderTypes";
import { useDispatch } from "react-redux";

export default () => {
    const dispatch = useDispatch();

    return (parameter: HeaderHeightParameter) => {
        dispatch(setHeaderHeight(parameter));
    };
};
